import {
  Box,
  Container,
  Grid,
  TextField,
  Typography,
  Button,
  InputAdornment,
  IconButton,
  Stack,
  CircularProgress,
  CssBaseline,
  Avatar,
  Link,
  Checkbox,
  FormControlLabel,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItem,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { LoadingButton } from "@mui/lab";
import { useLoaderData, useNavigate } from "react-router-dom";
import HttpsIcon from "@mui/icons-material/Https";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthService from "../../services/auth.service";
import { auth } from "./firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";

export default function SignUp() {
  const navigate = useNavigate();

  const phonecode = useLoaderData();

  console.log("phonecode", phonecode);

  const initialUserService = {
    name: "",
    email: "",
    mobile: "",
    password: "",
    code: phonecode,
    deviceType: "Web",
    referralCode: "",
  };

  const [showPassword, setShowPassword] = useState(false);
  const [hasFilled, setHasFilled] = useState(false);
  const [otp, setOtp] = useState("");
  // const [phone, setPhone] = useState(initialUserService.mobile);
  const [isVerified, setIsVerified] = useState(false);
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  // const [countryCode, setCountrycode] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [signingUp, setSigningUp] = useState(false);
  const [prevPhone, setPrevPhone] = useState("");
  const [prevPhoneCode, setPrevPhoneCode] = useState("");

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const generateRecaptcha = () => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      "recaptcha",
      {
        size: "invisible",
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // ...
        },
      },
      auth
    );
  };

  // Get expected phone number length based on country code
  const getPhoneLength = (code) => {
    const phoneLengths = {
      '+91': 10,   // India
      '+1': 10,    // US/Canada
      '+44': 10,   // UK
      '+61': 9,    // Australia
      '+971': 9,   // UAE
      '+880': 10,  // Bangladesh
      '+92': 10,   // Pakistan
      '+86': 11,   // China
      '+81': 10,   // Japan
      '+82': 10,   // South Korea
      '+65': 8,    // Singapore
      '+60': 10,   // Malaysia
      '+63': 10,   // Philippines
      '+66': 9,    // Thailand
      '+49': 11,   // Germany
      '+33': 9,    // France
      '+39': 10,   // Italy
      '+34': 9,    // Spain
    };
    // Caribbean codes like +1-268, +1-246 etc → 7 digits (after the +1-xxx prefix)
    if (code && code.startsWith('+1-')) return 7;
    return phoneLengths[code] || 15; // Default max 15 (ITU-T E.164)
  };

  let phoneNumber;

  const handleSend = async (event) => {
    console.log("handleSend triggered");
    event.preventDefault();
    setVerifying(true);

    // Initial validation
    if (!user.code) {
      toast.error("Please select ISD Code");
      setVerifying(false);
      return;
    }
    if (!user.mobile) {
      toast.error("Please fill your mobile number");
      setVerifying(false);
      return;
    }
    const expectedLen = getPhoneLength(user.code);
    if (user.mobile.length !== expectedLen) {
      toast.error(`Phone number must be exactly ${expectedLen} digits for ${user.code}`);
      setVerifying(false);
      return;
    }

    // Phone number formatting: user.code already starts with '+' (e.g., '+91')
    const finalPhoneNumber = `${user.code}${user.mobile}`;
    console.log("Formatted Phone Number:", finalPhoneNumber);
    setPreviousNumber(finalPhoneNumber);

    try {
      // Step 1: Pre-verify availability with Backend
      console.log("Checking availability for:", user.email, user.code, user.mobile);
      const availabilityRes = await AuthService.checkAvailability({
        email: user.email,
        code: user.code,
        mobile: user.mobile
      });

      console.log("Availability response:", availabilityRes.data);

      if (!availabilityRes.data.status) {
        toast.error(availabilityRes.data.message || "Data already exists!");
        setVerifying(false);
        return;
      }

      // Step 2: Clear old recaptcha if exists
      if (window.recaptchaVerifier) {
        console.log("Clearing existing recaptchaVerifier");
        try {
          window.recaptchaVerifier.clear();
        } catch (e) {
          console.error("Error clearing recaptcha:", e);
        }
        window.recaptchaVerifier = null;
      }
      // Reset the recaptcha container to remove any rendered widget
      const recaptchaContainer = document.getElementById("recaptcha");
      if (recaptchaContainer) {
        recaptchaContainer.innerHTML = "";
      }

      // Step 3: Generate Recaptcha
      console.log("Generating new recaptchaVerifier");
      generateRecaptcha();
      let appVerifier = window.recaptchaVerifier;

      // Step 4: Send OTP
      console.log("Calling signInWithPhoneNumber...");
      signInWithPhoneNumber(auth, finalPhoneNumber, appVerifier)
        .then((confirmationResult) => {
          console.log("OTP Sent Successfully, confirmationResult received");
          window.confirmationResult = confirmationResult;
          setOtpDialogOpen(true);
          toast.success("OTP Sent Successfully");
          setVerifying(false);
        })
        .catch((error) => {
          console.error("Firebase Auth Error:", error);
          let errorMessage = "Failed to send OTP. " + (error.message || "");

          if (error.code === 'auth/invalid-app-credential') {
            errorMessage = "Invalid App Credentials. Please check if your domain is authorized in Firebase console.";
          } else if (error.code === 'auth/too-many-requests') {
            errorMessage = "Too many OTP requests. Please try again later.";
          }

          toast.error(errorMessage);
          setVerifying(false);
          if (window.recaptchaVerifier) {
            window.recaptchaVerifier.clear();
            window.recaptchaVerifier = null;
          }
        });
    } catch (error) {
      console.error("Availability Check Failed:", error);
      const msg = error.response?.data?.message || "Availability check failed. Please check backend connection.";
      toast.error(msg);
      setVerifying(false);
    }
  };

  const handleResendOtp = async (event) => {
    event.preventDefault();
    setVerifying(true);
    setTimer(60);
    setTimerReachedZero(false);

    phoneNumber = `+${user.code}${user.mobile}`;

    try {
      let appVerifier = window.recaptchaVerifier;
      if (!appVerifier) {
        generateRecaptcha();
        appVerifier = window.recaptchaVerifier;
      }

      signInWithPhoneNumber(auth, phoneNumber, appVerifier)
        .then((confirmationResult) => {
          window.confirmationResult = confirmationResult;
          toast.success("OTP Resent Successfully");
          setVerifying(false);
        })
        .catch((error) => {
          console.error("Firebase Resend Error:", error);
          toast.error("Failed to resend OTP. Please try again.");
          setVerifying(false);
        });
    } catch (error) {
      toast.error("Verification failed.");
      setVerifying(false);
    }
  };

  const verifyOtp = (event) => {
    if (!otp) {
      toast.error("Please enter your OTP");
      return;
    }
    if (otp.length !== 6) {
      toast.error("OTP must be 6 digits");
      return;
    }

    setVerifying(true);
    let confirmationResult = window.confirmationResult;

    if (!confirmationResult) {
      toast.error("Verification session expired. Please resend OTP.");
      setOtpDialogOpen(false);
      setHasFilled(false);
      setVerifying(false);
      return;
    }

    confirmationResult
      .confirm(otp)
      .then((result) => {
        let firebaseUser = result.user;
        setPrevPhone(firebaseUser.phoneNumber);

        window.confirmationResult = null;
        setOtpDialogOpen(false);
        setIsVerified(true);
        setVerifying(false);
        toast.success("OTP verified Successfully");
      })
      .catch((error) => {
        console.error("OTP Verify Error:", error);
        toast.error("Invalid OTP code. Please try again.");
        setVerifying(false);
      });
  };

  const handleCloseOtpDialog = () => {
    window.confirmationResult = null;
    window.recaptchaVerifier.clear();

    // Reset the OTP dialog and data

    setOtpDialogOpen(false);
    setHasFilled(false);
  };

  const [user, setUser] = useState(initialUserService);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get("https://ipapi.co/json/");
  //       const data = response.data;

  //       console.log("data", data);

  //       // Set default value for the code field based on the API response
  //       const defaultCode = data.country_calling_code; // Replace with your logic
  //       setUser((prevUser) => ({ ...prevUser, code: defaultCode }));
  //     } catch (error) {
  //       console.error("Error fetching IP API data:", error);
  //       // Handle errors as needed
  //     }
  //   };

  //   fetchData(); // Call the function inside useEffect
  // }, []); // Empty dependency array means this effect runs once when the component mounts

  const [termsCondition, setTermsCondition] = useState(false);

  const handleTermsConditionChange = (e) => {
    setTermsCondition(e.target.checked);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const isValidEmail = (email) => {
    // Email validation regular expression
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };
  const isValidPhoneNumber = (mobile) => {
    // Only digits allowed
    if (!/^\d+$/.test(mobile)) return false;
    const expectedLen = getPhoneLength(user.code);
    return mobile.length === expectedLen;
  };

  const isValidName = (name) => {
    // Regular expression to allow only letters and spaces
    const namePattern = /^[A-Za-z\s]+$/;
    return namePattern.test(name);
  };

  const isValidReferralCode = (referralCode) => {
    // Regular expression to allow only numbers
    const codePattern = /^\d+$/;
    return codePattern.test(referralCode);
  };

  const handleSignup = async () => {
    setSigningUp(true);

    if (!user.name.trim()) {
      toast.error("Please Enter your name");
      setSigningUp(false);
      return;
    }
    if (!isValidName(user.name)) {
      toast.error("Name can only contain letters and spaces");
      setSigningUp(false);
      return;
    }

    if (!user.email.trim()) {
      toast.error("Please enter your email");
      setSigningUp(false);
      return;
    }

    const isEmailValid = isValidEmail(user.email);
    if (!isEmailValid) {
      toast.error("Invalid email format");
      setSigningUp(false);
      return;
    }

    if (!user.code) {
      toast.error("Please select a ISD code");
      setSigningUp(false);
      return;
    }
    if (!user.mobile) {
      toast.error("Please enter your phone number");
      setSigningUp(false);
      return;
    }
    if (!isVerified) {
      toast.error("number is not verified");
      setSigningUp(false);
      return;
    }
    if (!user.password) {
      toast.error("Please enter your password");
      setSigningUp(false);
      return;
    }

    if (user.referralCode !== "" && !isValidReferralCode(user.referralCode)) {
      toast.error("Referral code can only contain numbers");
      setSigningUp(false);
      return;
    }

    if (!termsCondition) {
      toast.error("Please Checked term & Condtion!");
      setSigningUp(false);
      return;
    }

    const isPhoneNumberValid = isValidPhoneNumber(user.mobile);
    if (!isPhoneNumberValid) {
      toast.error("Invalid phone number");
      setSigningUp(false);
      return;
    }

    const phoneNumberWithCode = `${user.code}`;

    AuthService.create({ ...user, code: phoneNumberWithCode })
      .then((response) => {

        setUser(initialUserService);
        setSigningUp(false);
        toast.success("SignUp Successfully");
        setIsVerified(false);
        navigate("/login");
      })
      .catch((error) => {
        setSigningUp(false);
        console.error("Signup error:", error);

        if (error.response?.data?.message) {
          toast.error(`${error.response.data.message}`);
        } else if (error.request) {
          // The request was made but no response was received
          toast.error("Network error. Please check your internet connection or try again later.");
        } else {
          // Something happened in setting up the request that triggered an Error
          toast.error("An unexpected error occurred. Please try again.");
        }
      });
  };
  const [timer, setTimer] = useState(60);
  const [timerReachedZero, setTimerReachedZero] = useState(false);

  useEffect(() => {
    let interval;
    if (otpDialogOpen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setTimerReachedZero(true);
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [otpDialogOpen, timer]);

  const [previousNumbers, setPreviousNumber] = useState("");

  const phoneNumberWithCode = `+${user.code}${user.mobile}`;
  // // const  previousNumber= `${prevPhoneCode}${prevPhone}`;

  useEffect(() => {
    console.log("prevPhone", previousNumbers, "Phone", phoneNumberWithCode);

    if (previousNumbers === phoneNumberWithCode) {
      setIsVerified(true);
    }
  }, [user.code, user.mobile]);

  const [isItemSelected, setIsItemSelected] = useState(false);

  const [countrySearch, setCountrySearch] = useState("");

  const filteredCountryCodes = countryCodes.filter(country =>
    country.label.toLowerCase().includes(countrySearch.toLowerCase()) ||
    country.phone.includes(countrySearch)
  );

  return (
    <div className="app__container">
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Helmet>
          <title>Register | Carib Bargains</title>
          <meta name="description" content="Carib Bargains Register"></meta>
        </Helmet>
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
            borderRadius: "15px",
            padding: "30px",
            background: "#fff",
          }}
        >
          <Avatar sx={{ bgcolor: "warning.main" }}>
            <HttpsIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign Up
          </Typography>
          <TextField
            id="fullname"
            name="name"
            label="Full Name"
            value={user.name}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            required
            autoFocus
            autoComplete="Full Name"
            inputProps={{ maxLength: 45 }}
          />

          <TextField
            id="email"
            name="email"
            label="Email address"
            value={user.email}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            required
            autoComplete="email"
          />
          <TextField
            name="mobile"
            id="mobile"
            label={`Phone number (${getPhoneLength(user.code)} digits)`}
            type="tel"
            fullWidth
            value={user.mobile}
            onChange={(event) => {
              const { name, value } = event.target;
              // Allow only digits and enforce max length
              const digitsOnly = value.replace(/\D/g, '');
              const maxLen = getPhoneLength(user.code);
              if (digitsOnly.length <= maxLen) {
                setUser({ ...user, [name]: digitsOnly });
                setIsVerified(false);
              }
            }}
            inputProps={{ maxLength: getPhoneLength(user.code) }}
            margin="normal"
            required
            autoComplete="Phone Number"
            InputProps={{
              inputProps: {
                inputMode: "numeric", // Enables numeric keyboard on mobile devices
                pattern: "[0-9]*", // Allows only numeric input
              },
              startAdornment: (
                <FormControl variant="standard" sx={{ ml: -1, minWidth: 80 }}>
                  <Select
                    id="code"
                    label="code"
                    name="code"
                    value={user.code}
                    onChange={(e) => {
                      setUser({ ...user, code: e.target.value });
                      setIsVerified(false);
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 400,
                          padding: '10px'
                        }
                      }
                    }}
                  >
                    <ListItem sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'white' }}>
                      <TextField
                        size="small"
                        autoFocus
                        placeholder="Search..."
                        fullWidth
                        value={countrySearch}
                        onChange={(e) => setCountrySearch(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key !== 'Escape') {
                            // Prevents focus loss when typing in search
                            e.stopPropagation();
                          }
                        }}
                      />
                    </ListItem>
                    {filteredCountryCodes.map((country) => (
                      <MenuItem key={country.phone} value={country.phone}>
                        {country.label} ({country.phone})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ),
              endAdornment: (
                <React.Fragment>
                  {isVerified ? (
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="body2" sx={{ color: "green", fontWeight: "bold" }}>
                        Verified
                      </Typography>
                      <CheckCircleIcon style={{ color: "green" }} />
                    </Stack>
                  ) : (
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      onClick={handleSend}
                      disabled={verifying}
                    >
                      {verifying ? <CircularProgress size={20} color="inherit" /> : "Verify"}
                    </Button>
                  )}
                </React.Fragment>
              ),
            }}
          />

          <TextField
            fullWidth
            margin="normal"
            id="password"
            required
            autoComplete="password"
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            value={user.password}
            onChange={handleInputChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            id="referralCode"
            name="referralCode"
            label="Refferal Code"
            value={user.referralCode}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            autoComplete="Refferal Code"
            inputProps={{ maxLength: 6 }}
          />
          <FormControlLabel
            id="termsCondition"
            control={<Checkbox checked={termsCondition} />} // Use the checked prop to set the checkbox state
            onChange={handleTermsConditionChange}
            // value={termsCondition}
            // onChange={handleTermsConditionChange}
            label={
              <Typography>
                By creating an account, you agree to our{" "}
                <a
                  href="https://caribbargains.com/term-condition"
                  target="_blank"
                  // rel="noopener noreferrer"
                  style={{ color: "blue", fontWeight: "bold" }}
                >
                  Terms and Conditions
                </a>
              </Typography>
            }
          />
          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            color="warning"
            onClick={handleSignup}
            loading={signingUp}
            loadingPosition="start"
            startIcon={signingUp ? <CircularProgress size={20} /> : null}
            sx={{ mt: 1, mb: 2 }}
          >
            Sign Up
          </LoadingButton>

          <Grid container justifyContent="flex-end">
            <Grid item>
              <Link
                href="#"
                variant="body2"
                component={RouterLink}
                to={"/login"}
              >
                {"Already have an account? Sign in"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <div id="recaptcha"></div>
      <Dialog
        open={otpDialogOpen}
        onClose={handleCloseOtpDialog}
        fullWidth={true}
        maxWidth={"xs"}
      >
        <DialogContent>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseOtpDialog}
            aria-label="close"
            sx={{ position: "absolute", top: 5, right: 12 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ mt: "10px", mb: "10px" }}
            variant="h5"
            component="div"
          >
            Enter the OTP
          </Typography>
          <TextField
            id="otp"
            fullWidth
            variant="outlined"
            label="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          {timerReachedZero ? (
            <div style={{ marginTop: 10 }}>
              <span variant="body2">If you didn't received a code? </span>
              <Link
                variant="outlined"
                color="primary"
                onClick={handleResendOtp}
                sx={{ mt: 2, cursor: "pointer" }}
                size="small"
              >
                Resend OTP
              </Link>
            </div>
          ) : (
            <div style={{ marginTop: "10px" }}>
              Time left:{" "}
              {Math.floor(timer / 60).toLocaleString(undefined, {
                minimumIntegerDigits: 2,
              })}
              :
              {(timer % 60).toLocaleString(undefined, {
                minimumIntegerDigits: 2,
              })}
            </div>
          )}
          <LoadingButton
            fullWidth
            size="large"
            type="button"
            variant="contained"
            color="warning"
            onClick={verifyOtp}
            loading={verifying}
            loadingPosition="start"
            startIcon={verifying ? <CircularProgress size={20} /> : null}
            sx={{ mt: 2 }}
          >
            Verify Code
          </LoadingButton>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const countryCodes = [
  { code: "AD", label: "Andorra", phone: "+376" },
  {
    code: "AE",
    label: "United Arab Emirates",
    phone: "+971",
  },
  { code: "AF", label: "Afghanistan", phone: "+93" },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    phone: "+1-268",
  },
  { code: "AI", label: "Anguilla", phone: "+1-264" },
  { code: "AL", label: "Albania", phone: "+355" },
  { code: "AM", label: "Armenia", phone: "+374" },
  { code: "AO", label: "Angola", phone: "+244" },
  { code: "AQ", label: "Antarctica", phone: "+672" },
  { code: "AR", label: "Argentina", phone: "+54" },
  { code: "AS", label: "American Samoa", phone: "+1-684" },
  { code: "AT", label: "Austria", phone: "+43" },
  {
    code: "AU",
    label: "Australia",
    phone: "+61",
    suggested: true,
  },
  { code: "AW", label: "Aruba", phone: "+297" },
  { code: "AX", label: "Alland Islands", phone: "+358" },
  { code: "AZ", label: "Azerbaijan", phone: "+994" },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    phone: "+387",
  },
  { code: "BB", label: "Barbados", phone: "+1-246" },
  { code: "BD", label: "Bangladesh", phone: "+880" },
  { code: "BE", label: "Belgium", phone: "+32" },
  { code: "BF", label: "Burkina Faso", phone: "+226" },
  { code: "BG", label: "Bulgaria", phone: "+359" },
  { code: "BH", label: "Bahrain", phone: "+973" },
  { code: "BI", label: "Burundi", phone: "+257" },
  { code: "BJ", label: "Benin", phone: "+229" },
  { code: "BL", label: "Saint Barthelemy", phone: "+590" },
  { code: "BM", label: "Bermuda", phone: "+1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "+673" },
  { code: "BO", label: "Bolivia", phone: "+591" },
  { code: "BR", label: "Brazil", phone: "+55" },
  { code: "BS", label: "Bahamas", phone: "+1-242" },
  { code: "BT", label: "Bhutan", phone: "+975" },
  { code: "BV", label: "Bouvet Island", phone: "+47" },
  { code: "BW", label: "Botswana", phone: "+267" },
  { code: "BY", label: "Belarus", phone: "+375" },
  { code: "BZ", label: "Belize", phone: "+501" },
  {
    code: "CA",
    label: "Canada",
    phone: "+1",
    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    phone: "+61",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    phone: "+243",
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "+236",
  },
  {
    code: "CG",
    label: "Congo, Republic of the",
    phone: "+242",
  },
  { code: "CH", label: "Switzerland", phone: "+41" },
  { code: "CI", label: "Cote d'Ivoire", phone: "+225" },
  { code: "CK", label: "Cook Islands", phone: "+682" },
  { code: "CL", label: "Chile", phone: "+56" },
  { code: "CM", label: "Cameroon", phone: "+237" },
  { code: "CN", label: "China", phone: "+86" },
  { code: "CO", label: "Colombia", phone: "+57" },
  { code: "CR", label: "Costa Rica", phone: "+506" },
  { code: "CU", label: "Cuba", phone: "+53" },
  { code: "CV", label: "Cape Verde", phone: "+238" },
  { code: "CW", label: "Curacao", phone: "+599" },
  { code: "CX", label: "Christmas Island", phone: "+61" },
  { code: "CY", label: "Cyprus", phone: "+357" },
  { code: "CZ", label: "Czech Republic", phone: "+420" },
  {
    code: "DE",
    label: "Germany",
    phone: "+49",
    suggested: true,
  },
  { code: "DJ", label: "Djibouti", phone: "+253" },
  { code: "DK", label: "Denmark", phone: "+45" },
  { code: "DM", label: "Dominica", phone: "+1-767" },
  {
    code: "DO",
    label: "Dominican Republic",
    phone: "+1-809",
  },
  { code: "DZ", label: "Algeria", phone: "+213" },
  { code: "EC", label: "Ecuador", phone: "+593" },
  { code: "EE", label: "Estonia", phone: "+372" },
  { code: "EG", label: "Egypt", phone: "+20" },
  { code: "EH", label: "Western Sahara", phone: "+212" },
  { code: "ER", label: "Eritrea", phone: "+291" },
  { code: "ES", label: "Spain", phone: "+34" },
  { code: "ET", label: "Ethiopia", phone: "+251" },
  { code: "FI", label: "Finland", phone: "+358" },
  { code: "FJ", label: "Fiji", phone: "+679" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "+500",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "+691",
  },
  { code: "FO", label: "Faroe Islands", phone: "+298" },
  {
    code: "FR",
    label: "France",
    phone: "+33",
    suggested: true,
  },
  { code: "GA", label: "Gabon", phone: "+241" },
  { code: "GB", label: "United Kingdom", phone: "+44" },
  { code: "GD", label: "Grenada", phone: "+1-473" },
  { code: "GE", label: "Georgia", phone: "+995" },
  { code: "GF", label: "French Guiana", phone: "+594" },
  { code: "GG", label: "Guernsey", phone: "+44" },
  { code: "GH", label: "Ghana", phone: "+233" },
  { code: "GI", label: "Gibraltar", phone: "+350" },
  { code: "GL", label: "Greenland", phone: "+299" },
  { code: "GM", label: "Gambia", phone: "+220" },
  { code: "GN", label: "Guinea", phone: "+224" },
  { code: "GP", label: "Guadeloupe", phone: "+590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "+240" },
  { code: "GR", label: "Greece", phone: "+30" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "+500",
  },
  { code: "GT", label: "Guatemala", phone: "+502" },
  { code: "GU", label: "Guam", phone: "+1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "+245" },
  { code: "GY", label: "Guyana", phone: "+592" },
  { code: "HK", label: "Hong Kong", phone: "+852" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "+672",
  },
  { code: "HN", label: "Honduras", phone: "+504" },
  { code: "HR", label: "Croatia", phone: "+385" },
  { code: "HT", label: "Haiti", phone: "+509" },
  { code: "HU", label: "Hungary", phone: "+36" },
  { code: "ID", label: "Indonesia", phone: "+62" },
  { code: "IE", label: "Ireland", phone: "+353" },
  { code: "IL", label: "Israel", phone: "+972" },
  { code: "IM", label: "Isle of Man", phone: "+44" },
  { code: "IN", label: "India", phone: "+91" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "+246",
  },
  { code: "IQ", label: "Iraq", phone: "+964" },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    phone: "+98",
  },
  { code: "IS", label: "Iceland", phone: "+354" },
  { code: "IT", label: "Italy", phone: "+39" },
  { code: "JE", label: "Jersey", phone: "+44" },
  { code: "JM", label: "Jamaica", phone: "+1-876" },
  { code: "JO", label: "Jordan", phone: "+962" },
  {
    code: "JP",
    label: "Japan",
    phone: "+81",
    suggested: true,
  },
  { code: "KE", label: "Kenya", phone: "+254" },
  { code: "KG", label: "Kyrgyzstan", phone: "+996" },
  { code: "KH", label: "Cambodia", phone: "+855" },
  { code: "KI", label: "Kiribati", phone: "+686" },
  { code: "KM", label: "Comoros", phone: "+269" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "+1-869",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "+850",
  },
  { code: "KR", label: "Korea, Republic of", phone: "+82" },
  { code: "KW", label: "Kuwait", phone: "+965" },
  { code: "KY", label: "Cayman Islands", phone: "+1-345" },
  { code: "KZ", label: "Kazakhstan", phone: "+7" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "+856",
  },
  { code: "LB", label: "Lebanon", phone: "+961" },
  { code: "LC", label: "Saint Lucia", phone: "+1-758" },
  { code: "LI", label: "Liechtenstein", phone: "+423" },
  { code: "LK", label: "Sri Lanka", phone: "+94" },
  { code: "LR", label: "Liberia", phone: "+231" },
  { code: "LS", label: "Lesotho", phone: "+266" },
  { code: "LT", label: "Lithuania", phone: "+370" },
  { code: "LU", label: "Luxembourg", phone: "+352" },
  { code: "LV", label: "Latvia", phone: "+371" },
  { code: "LY", label: "Libya", phone: "+218" },
  { code: "MA", label: "Morocco", phone: "+212" },
  { code: "MC", label: "Monaco", phone: "+377" },
  {
    code: "MD",
    label: "Moldova, Republic of",
    phone: "+373",
  },
  { code: "ME", label: "Montenegro", phone: "+382" },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    phone: "+590",
  },
  { code: "MG", label: "Madagascar", phone: "+261" },
  { code: "MH", label: "Marshall Islands", phone: "+692" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "+389",
  },
  { code: "ML", label: "Mali", phone: "+223" },
  { code: "MM", label: "Myanmar", phone: "+95" },
  { code: "MN", label: "Mongolia", phone: "+976" },
  { code: "MO", label: "Macao", phone: "+853" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "+1-670",
  },
  { code: "MQ", label: "Martinique", phone: "+596" },
  { code: "MR", label: "Mauritania", phone: "+222" },
  { code: "MS", label: "Montserrat", phone: "+1-664" },
  { code: "MT", label: "Malta", phone: "+356" },
  { code: "MU", label: "Mauritius", phone: "+230" },
  { code: "MV", label: "Maldives", phone: "+960" },
  { code: "MW", label: "Malawi", phone: "+265" },
  { code: "MX", label: "Mexico", phone: "+52" },
  { code: "MY", label: "Malaysia", phone: "+60" },
  { code: "MZ", label: "Mozambique", phone: "+258" },
  { code: "NA", label: "Namibia", phone: "+264" },
  { code: "NC", label: "New Caledonia", phone: "+687" },
  { code: "NE", label: "Niger", phone: "+227" },
  { code: "NF", label: "Norfolk Island", phone: "+672" },
  { code: "NG", label: "Nigeria", phone: "+234" },
  { code: "NI", label: "Nicaragua", phone: "+505" },
  { code: "NL", label: "Netherlands", phone: "+31" },
  { code: "NO", label: "Norway", phone: "+47" },
  { code: "NP", label: "Nepal", phone: "+977" },
  { code: "NR", label: "Nauru", phone: "+674" },
  { code: "NU", label: "Niue", phone: "+683" },
  { code: "NZ", label: "New Zealand", phone: "+64" },
  { code: "OM", label: "Oman", phone: "+968" },
  { code: "PA", label: "Panama", phone: "+507" },
  { code: "PE", label: "Peru", phone: "+51" },
  { code: "PF", label: "French Polynesia", phone: "+689" },
  { code: "PG", label: "Papua New Guinea", phone: "+675" },
  { code: "PH", label: "Philippines", phone: "+63" },
  { code: "PK", label: "Pakistan", phone: "+92" },
  { code: "PL", label: "Poland", phone: "+48" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "+508",
  },
  { code: "PN", label: "Pitcairn", phone: "+870" },
  { code: "PR", label: "Puerto Rico", phone: "+1" },
  {
    code: "PS",
    label: "Palestine, State of",
    phone: "+970",
  },
  { code: "PT", label: "Portugal", phone: "+351" },
  { code: "PW", label: "Palau", phone: "+680" },
  { code: "PY", label: "Paraguay", phone: "+595" },
  { code: "QA", label: "Qatar", phone: "+974" },
  { code: "RE", label: "Reunion", phone: "+262" },
  { code: "RO", label: "Romania", phone: "+40" },
  { code: "RS", label: "Serbia", phone: "+381" },
  { code: "RU", label: "Russian Federation", phone: "+7" },
  { code: "RW", label: "Rwanda", phone: "+250" },
  { code: "SA", label: "Saudi Arabia", phone: "+966" },
  { code: "SB", label: "Solomon Islands", phone: "+677" },
  { code: "SC", label: "Seychelles", phone: "+248" },
  { code: "SD", label: "Sudan", phone: "+249" },
  { code: "SE", label: "Sweden", phone: "+46" },
  { code: "SG", label: "Singapore", phone: "+65" },
  { code: "SH", label: "Saint Helena", phone: "+290" },
  { code: "SI", label: "Slovenia", phone: "+386" },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
    phone: "+47",
  },
  { code: "SK", label: "Slovakia", phone: "+421" },
  { code: "SL", label: "Sierra Leone", phone: "+232" },
  { code: "SM", label: "San Marino", phone: "+378" },
  { code: "SN", label: "Senegal", phone: "+221" },
  { code: "SO", label: "Somalia", phone: "+252" },
  { code: "SR", label: "Suriname", phone: "+597" },
  { code: "SS", label: "South Sudan", phone: "+211" },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    phone: "+239",
  },
  { code: "SV", label: "El Salvador", phone: "+503" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "+1-721",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
    phone: "+963",
  },
  { code: "SZ", label: "Swaziland", phone: "+268" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "+1-649",
  },
  { code: "TD", label: "Chad", phone: "+235" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "+262",
  },
  { code: "TG", label: "Togo", phone: "+228" },
  { code: "TH", label: "Thailand", phone: "+66" },
  { code: "TJ", label: "Tajikistan", phone: "+992" },
  { code: "TK", label: "Tokelau", phone: "+690" },
  { code: "TL", label: "Timor-Leste", phone: "+670" },
  { code: "TM", label: "Turkmenistan", phone: "+993" },
  { code: "TN", label: "Tunisia", phone: "+216" },
  { code: "TO", label: "Tonga", phone: "+676" },
  { code: "TR", label: "Turkey", phone: "+90" },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    phone: "+1-868",
  },
  { code: "TV", label: "Tuvalu", phone: "+688" },
  {
    code: "TW",
    label: "Taiwan, Republic of China",
    phone: "+886",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "+255",
  },
  { code: "UA", label: "Ukraine", phone: "+380" },
  { code: "UG", label: "Uganda", phone: "+256" },
  {
    code: "US",
    label: "United States",
    phone: "+1",
    suggested: true,
  },
  { code: "UY", label: "Uruguay", phone: "+598" },
  { code: "UZ", label: "Uzbekistan", phone: "+998" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "+379",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "+1-784",
  },
  { code: "VE", label: "Venezuela", phone: "+58" },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "+1-284",
  },
  {
    code: "VI",
    label: "US Virgin Islands",
    phone: "+1-340",
  },
  { code: "VN", label: "Vietnam", phone: "+84" },
  { code: "VU", label: "Vanuatu", phone: "+678" },
  { code: "WF", label: "Wallis and Futuna", phone: "+681" },
  { code: "WS", label: "Samoa", phone: "+685" },
  { code: "XK", label: "Kosovo", phone: "+383" },
  { code: "YE", label: "Yemen", phone: "+967" },
  { code: "YT", label: "Mayotte", phone: "+262" },
  { code: "ZA", label: "South Africa", phone: "+27" },
  { code: "ZM", label: "Zambia", phone: "+260" },
  { code: "ZW", label: "Zimbabwe", phone: "+263" },
];
